import { getMyPageTieup } from "../../api/v1/mypage/tieup/get"
import { MyPageTieupGetInputModel } from "../../api/v1/mypage/tieup/GetInputModel"
import { TieupRequestStatus } from "./TieupRequestStatus"
import { Paging } from "../paging/paging"
import { RequestedTieup } from "./RequestedTieup"
import { adaptRequestedTieup } from "./adaptRequestdTieup"

interface Params {
  limit?: number
  offset?: number
  requestAcceptStatus?: TieupRequestStatus
}

export const fetchOwnRequestedTieups = (
  params: Params = {},
): Promise<Paging<RequestedTieup>> => {
  return getMyPageTieup(new MyPageTieupGetInputModel(params)).then((v) => {
    return {
      total: v.count,
      items: v.results.map(adaptRequestedTieup),
    }
  })
}
